"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24CartLine = function Svg24CartLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.278 4.006A7.023 7.023 0 0 0 3.865 4H3a1 1 0 0 1 0-2h.951c.313-.002.706-.003 1.063.136a2 2 0 0 1 .797.565c.25.292.377.663.48.958l.028.082.09.259h12.185c.373 0 .718 0 1 .026.293.026.661.09.998.318a2 2 0 0 1 .846 1.293c.074.4-.016.762-.109 1.042-.09.268-.228.584-.377.926l-2.116 4.837-.032.073c-.116.267-.26.602-.508.863a1.998 1.998 0 0 1-.769.502c-.338.123-.703.121-.993.12h-7.48l-.676 1.082a12.721 12.721 0 0 0-.53.894l.037.003c.212.02.51.021 1.002.021H18a1 1 0 1 1 0 2H8.844c-.434 0-.827 0-1.142-.029-.317-.029-.73-.098-1.09-.365a2 2 0 0 1-.801-1.446c-.036-.447.124-.834.268-1.118.142-.283.35-.615.58-.984l.739-1.18L4.43 4.401a7.03 7.03 0 0 0-.142-.388l-.003-.007h-.008zM9.21 12l-2.1-6h11.445c.427 0 .679.001.859.017l.027.003-.008.027a11.01 11.01 0 0 1-.329.793l-2.1 4.8c-.08.185-.123.281-.158.348l-.003.006h-.006c-.076.005-.18.006-.382.006H9.209z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M7.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM16.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24CartLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24CartLine;
exports.default = _default;